import { _ } from '../utils.js'

class SimpleFilter {
    constructor(el) {
        this.el = el
        this.items = _('simple-filter-item', 'element2').nodesFrom(this.el)
        this.filter = _('simpleFilter', 'element').nodeFrom(this.el)
        this.filter.addEventListener('change', this.filterItems)
    }

    filterItems = (e) => {
        this.items.forEach((item) => {
            if (e.target.value === 'all' || e.target.value === '') {
                item.classList.remove('u-hidden')
            } else {
                if (e.target.value !== item.dataset.value) {
                    item.classList.add('u-hidden')
                } else {
                    item.classList.remove('u-hidden')
                }
            }
        })
    }
}

export default SimpleFilter
